// Copyright © 2021 Move Closer
import { TokenType } from '@d24/demarked';
import { AbstractAdapter, getIdentifierConstraint, getRelatedTypeConstraint } from '../_abstract/adapter';
import { getModuleBase } from '../_helpers/adapter';
import { ModuleDriver } from '../_contracts';
import { RelatedType } from '../../services';
import { GallerySelectionOptions, GalleryVersion } from './Gallery.contracts';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export class GalleryAdapter extends AbstractAdapter {
    /**
     * Adapts (translates/maps) the passed-in `GalleryModule` to `GalleryToken`.
     *
     * @param object - The module to adapt.
     */
    objectToToken(object) {
        this.validate(object, {
            content: {
                presence: true,
                type: 'object'
            },
            'content.gallery': {
                presence: true,
                type: 'object'
            },
            'content.gallery.type': getRelatedTypeConstraint(RelatedType.Gallery),
            'content.gallery.value': getIdentifierConstraint(),
            version: {
                type: 'string',
                equality: {
                    attribute: '-',
                    comparator: (value) => Object.values(GalleryVersion).includes(value)
                }
            }
        });
        const id = object.content.gallery.value;
        const version = typeof object.version === 'string'
            ? object.version
            : GalleryVersion.Carousel;
        return {
            content: id,
            meta: { version },
            raw: `#GALLERY[ id: ${id} | version: ${version} ]`,
            type: TokenType.Gallery
        };
    }
    /**
     * Adapts (translates/maps) the passed-in `GalleryToken` to `GalleryModule`.
     *
     * @param token - The token to adapt.
     */
    tokenToObject(token) {
        this.validate(token, {
            content: getIdentifierConstraint(),
            'meta.version': {
                type: 'string',
                equality: {
                    attribute: '-',
                    comparator: (value) => Object.values(GalleryVersion).includes(value)
                }
            }
        });
        const id = token.content;
        let version = GalleryVersion.Carousel;
        if (typeof token.meta !== 'undefined' && typeof token.meta.version === 'string') {
            version = token.meta.version;
        }
        return {
            ...getModuleBase(),
            content: {
                gallery: {
                    type: RelatedType.Gallery,
                    value: id
                },
                // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                // @ts-ignore
                galleryType: (id === '##GALERY_ID##' || id === -4) ? GallerySelectionOptions.Smart : GallerySelectionOptions.Default
            },
            driver: ModuleDriver.Gallery,
            version
        };
    }
}
